module.exports = __webpack_public_path__ + "img/btn_sound_on.4a05cd08.svg";